import Vue from 'vue'
import App from './App.vue'
import router from './router/core/index'
import vuetify from '@/global/vuetify/vuetify'
import '@babel/polyfill'
import vueNotification from './global/declarations/vue-notification'
import '@/layout/assets/sass/style.scss'

/**
 * #### Plugins iD3i ####
 */
import '@/configuration/id3i'

Vue.config.productionTip = false

new Vue({
    router,
    vuetify,
    // @ts-ignore
    vueNotification,
    render: h => h(App)
}).$mount('#app')
